"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.not = exports.or = exports.and = void 0;
exports.and = {
    test({ rule: { rules }, params, key, ruleTypes }) {
        return rules.every((rule) => ruleTypes[rule.type].test({ rule, params, key, ruleTypes }));
    }
};
exports.or = {
    test({ rule: { rules }, params, key, ruleTypes }) {
        return rules.some((rule) => ruleTypes[rule.type].test({ rule, params, key, ruleTypes }));
    }
};
exports.not = {
    test({ rule: { rule }, params, key, ruleTypes }) {
        return !ruleTypes[rule.type].test({ rule, params, key, ruleTypes });
    }
};
